export const API_URL = "https://smartplantsbolivia.com/api";
//export const API_URL = "http://localhost:4000/api";

export const APP_EXPO = "http://localhost:3000/#";

export const createHeader = (token) => {
  const headers = { headers: { "x-access-token": token } };
  return headers;
};
